export default {"src":"/_next/static/media/favourite.514f4507.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};